import type { FC } from 'react';
import { Route } from 'react-router';
import { useStorageServiceRoot } from 'src/apis/storage/use-storage-service-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { StorageLocationCreate } from 'src/pages/storage/locations/create';
import { StorageLocationDetails } from 'src/pages/storage/locations/details';
import { StorageLocationEdit } from 'src/pages/storage/locations/edit';
import { StorageLocationsOverview } from 'src/pages/storage/locations/overview';

export const StorageLocationsRoot: FC = () => {
  const storageServiceRoot = useStorageServiceRoot();

  if (!storageServiceRoot.response) {
    return <PageSpinner />;
  }

  return (
    <RootRoutes>
      <Route
        path="/storage/locations"
        element={
          <StorageLocationsOverview storageServiceRoot={storageServiceRoot} />
        }
      />
      <Route
        path="/storage/locations/create"
        element={
          <StorageLocationCreate storageServiceRoot={storageServiceRoot} />
        }
      />
      <Route
        path="/storage/locations/:locationId"
        element={
          <StorageLocationDetails storageServiceRoot={storageServiceRoot} />
        }
      />
      <Route
        path="/storage/locations/:locationId/edit"
        element={
          <StorageLocationEdit storageServiceRoot={storageServiceRoot} />
        }
      />

      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
